import { PayloadAction, createSlice } from '@reduxjs/toolkit';

/**
 * The help panel: whether it is open, and which article it is showing.
 *
 * Its own slice rather than `Modals.HELP`: the panel sits beside the page and
 * can be open while a dialog is, and `modals` holds one modal at a time.
 */
export interface IHelpState {
  open: boolean;
  /** The article being read in the panel, by slug. Null shows the page's list. */
  article: string | null;
}

const initialState: IHelpState = { open: false, article: null };

export const helpSlice = createSlice({
  name: 'help',
  initialState,
  reducers: {
    openHelp: (state, action: PayloadAction<{ article?: string } | undefined>) => {
      state.open = true;
      state.article = action.payload?.article ?? null;
    },
    showHelpArticle: (state, action: PayloadAction<string | null>) => {
      state.article = action.payload;
    },
    closeHelp: () => initialState,
    toggleHelp: state => (state.open ? initialState : { open: true, article: null }),
  },
});

export const { openHelp, showHelpArticle, closeHelp, toggleHelp } = helpSlice.actions;

export default helpSlice.reducer;
